/** Locale strings. English only for the first release; add locales here. */
export interface CalendarLocale {
  months: string[];
  monthsShort: string[];
  weekdays: string[]; // index 0 = Sunday
  weekdaysShort: string[];
  weekdaysNarrow: string[];
  weekLabel: string;
}

export const LOCALES: Record<string, CalendarLocale> = {
  en: {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysNarrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    weekLabel: 'Wk',
  },
};
export const getLocale = (code: string): CalendarLocale => LOCALES[code] ?? LOCALES.en;
